import { FC } from 'react';

import { pick, isEmpty } from 'lodash';
import { AccountCard } from 'utils/types';

import CardCall from '../assets/call.svg';
import CardSms from '../assets/sms.svg';
import CardLink from '../assets/link-2.svg';
import CardUser from '../assets/user-octagon.svg';

type PROPS = {
  accountCard: AccountCard;
};

const ICONS = {
  emailAddress: CardSms,
  mobileNumber: CardCall,
  websiteUrl: CardLink,
  jobDepartment: CardUser,
};

const CardContactDetails: FC<PROPS> = ({ accountCard }) => {
  const metaEntries = pick(accountCard.meta, [
    'emailAddress',
    'mobileNumber',
    'websiteUrl',
    'jobDepartment',
  ]);

  if (Object.values(metaEntries).filter((value) => !isEmpty(value)).length < 1)
    return null;

  return (
    <ul className="space-y-6">
      {Object.entries(metaEntries)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([_, value]) => !isEmpty(value))
        .map(([key, value]) => (
          <li key={key} className="flex space-x-2 items-center">
            <img
              src={ICONS[key as keyof typeof ICONS]}
              alt={key}
              className="inline-block mr-2"
            />
            <p className="text-sm text-text-secondary">{value}</p>
          </li>
        ))}
    </ul>
  );
};

export default CardContactDetails;
